var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBar',{attrs:{"menus":_vm.menus}}),_vm._l((_vm.menus),function(group){return _c('div',{key:group.menu._id},[_c('MenuTitle',{attrs:{"menu":group.menu}}),_vm._l((group.courses),function(cItem){return _c('CourseSection',{key:cItem.course._id,attrs:{"id":cItem.id,"data":cItem,"modifiers":_vm.modifiers}})})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }